import axios from 'axios';
import { Toast } from 'vant';
import { API_URL } from '@/config/dev';
import { sort_ASCII, setStorage, getStorage, deserialize, isAndroid, versionCompare } from '@/libs/utils';
import { Encrypt, Decrypt, base64Decrypt } from '@/libs/business/encrypt';
class HttpRequest {
  // constructor(params) {
  // }
  getInsideConfig() {
    const config = {
      baseURL: API_URL,
      headers: {},
      method: 'post', //  默认请求方式为post,其他方式需调request时另写
    };
    return config;
  }
  interceptors(instance) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        return config;
      },
      (error) => {
        return Promise.reject(error);
      },
    );
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        let { data, status, config } = res;
        if (status === 200) {
          // 加密接口返回值需要解密
          if (data.ret === 1 || data.code === 200 || data.status_code === 0 || data.code === 1 || config.third) {
            if (config.headers['encrypt-version'] == 'v1') {
              return {
                ...data,
                msg: base64Decrypt(data.msg),
                content: deserialize(Decrypt(data.content, config.headers['timestamp']))
              };
            }
            return data;
          } else {
            if ((data.msg || data.message) && !config.unHint) {
              if (config.headers['encrypt-version'] == 'v1') {
                Toast.fail({ message: base64Decrypt(data.msg || data.message), duration: 2000 });
                return Promise.reject(data);
              }
              Toast.fail({ message: data.msg || data.message, duration: 2000 });
            }
            return Promise.reject(data);
          }
        }
      },
      (error) => {
        let errorInfo = error.response;
        if (!errorInfo) {
          const {
            request: { message, status },
            config,
          } = error;
          errorInfo = {
            message,
            status,
            request: { responseURL: config.url },
          };
        }
        return Promise.reject(error);
      },
    );
  }
  async request(options, sign) {
    const instance = axios.create();
    const insideConfig = this.getInsideConfig();
    options = Object.assign(insideConfig, options);

    if (sign) {
      options.data = sort_ASCII(options.data);
    }
    this.interceptors(instance);
    return instance(options);
  }

  // 加密请求
  async ecRequest(options, sign) {
    const instance = axios.create();
    const insideConfig = this.getInsideConfig();

    options = Object.assign(insideConfig, options);

    const device_info = getStorage('device_info');
    if (isAndroid() && versionCompare(device_info.sdkVersion, '4.3.0')) {
      const timestamp = new Date().getTime();
      const user_id = getStorage('user_id');
      const access_token = getStorage('access_token');
      options.headers = {
        timestamp,
        'encrypt-version': 'v1', 
        'user-id': user_id,
        'access-token': Encrypt(access_token, timestamp),
      };
      options.data = {
        data: Encrypt(JSON.stringify(options.data), timestamp),
      };
    }

    this.interceptors(instance);
    return instance(options);
  }
}

export default new HttpRequest();
